import { locales } from '@/i18n-config';
import { PresentationIdentifier } from '@sales-domain/product-config';
import { usePathname } from 'next/navigation';

export interface PathConfig {
  basePath?: string;
  partnerIdentifier?: string;
  productIdentifier?: string;
  presentation?: string;
  currentStep?: string;
}

export function usePathSegments(): PathConfig {
  const pathname = usePathname();
  const paths = pathname.split('/').filter((path) => path !== '');

  // if the dynamic [lang] value is present, remove the value from the array
  if (locales.includes(paths[0])) {
    paths.shift();
  }

  // Affiliate uses a different path structure, with a hardcoded "affiliate" where the
  // product route would normally be, and a variable partner and product under that,
  // without any presentation.
  if (paths[0] === PresentationIdentifier.Affiliate && paths.length === 4) {
    const [basePath, partnerIdentifier, productIdentifier, currentStep] = paths;

    return {
      basePath,
      partnerIdentifier,
      productIdentifier,
      currentStep,
    };
  }

  // Different apps within D2C use different length paths:
  //    The "regular" flows use 4 path segments - [product]/[partner]/[presentation] and the current step
  //    GameStop agent uses 3 path segments: /protect/gamestop/personal-info
  //    customer-action uses 5 path segments with customer-action prepended to the variable route parts
  let basePath, partnerIdentifier, presentation, currentStep, extra;
  switch (paths.length) {
    case 4:
      [basePath, partnerIdentifier, presentation, currentStep] = paths;
      break;
    case 5:
      [extra, basePath, partnerIdentifier, presentation, currentStep] = paths;
      break;
    default:
      [basePath, partnerIdentifier, currentStep] = paths;
      break;
  }

  return {
    basePath,
    partnerIdentifier,
    presentation,
    currentStep,
  };
}
